import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../components/loader/loader.component';
import { selectDati, selectLoading, selectConsuntivo } from '../../redux/features/features.selectors';
import { getPagination } from '../../utilities/utility';

import './consuntivo.styles.css';
import { getConsuntivo, searchConsuntivo } from '../../redux/features/consuntivo/consuntivo.thunk';
import TabellaConsuntivo from '../../components/tabella-consuntivo/tabella-consuntivo.component';

const Consuntivo = () => {

	const dispatch = useDispatch();
	const dati = useSelector(selectDati);
	const consuntivo = useSelector(selectConsuntivo);
	const loading = useSelector(selectLoading);
	const [active, setActive] = useState(1);
	const [search, setSearch] = useState({
		dipendete: '',
		presenza: '',
		nome_breve: '',
		ordinario: '',
		straordinario: '',
		notturno: '',
		malattia: '',
		infortunio: '',
		note: ''
	})

	const { dipendente, presenza } = search;

	const pagine = getPagination(dati?.pagina, dati?.pagine, 4);

	useEffect(() => {
		dispatch(getConsuntivo(1));
	}, [dispatch]);

	const paginate = (pagina) => {
		setActive(pagina);
		dispatch(getConsuntivo(pagina));
	}

	const handleChange = (e) => {
		const { name, value } = e.target;
		setSearch({ ...search, [name]: value })
	}

	const handleCerca = async () => {
		await dispatch(searchConsuntivo({
			pagina: 1,
			ricerca: search
		}))

		//console.log(search);
	}

	return (loading) ? (
		<div className='attendere'>
			<Loader />
		</div>
	) : (
		(dati) ? (

			<div className="lista-dipendenti">
				<div className="row">
					<div className="col-lg-12">
						<div className="card">
							<div className="card-body">
								<form action="" id="" method="get">
									<p className="text-primary font-14"><strong>Cerca un dipendente</strong></p>
									<hr />

									<div className="row">
										<div className="col-lg-4">
											<div className="mb-3">
												<label htmlFor="dipendente" className="form-label">Dipendente</label>
												<input type="text" onChange={handleChange} className="form-control" value={dipendente} name="dipendente" id="dipendente" />
											</div>
										</div>
										<div className="col-lg-4">
											<div className="mb-3">
												<label htmlFor="presenza" className="form-label">Presenza</label>
												<input type="text" onChange={handleChange} className="form-control" value={presenza} name="presenza" id="presenza" />
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>

				<br />

				<div className="row">
					<div className="col-lg-12 text-center">
						<button type="button" onClick={handleCerca} className="btn btn-success">Cerca</button>
					</div>
				</div>

				<hr />

				<TabellaConsuntivo consuntivo={consuntivo} />

				<div className="row">
					<div className="col-md-4"></div>
					<div className="col-md-4">
						<nav>
							<ul className="pagination pagination-rounded mb-0 justify-content-center">

								<li className="page-item">
									<button className="page-link" onClick={pagine.first ? () => paginate(pagine.first) : null} aria-label="Previous">
										<span aria-hidden="true">&laquo;</span>
									</button>
								</li>
								{
									pagine.before.map((num) => (
										<li key={num} className={"page-item " + ((active === num) ? 'active' : null)}><button className="page-link" onClick={() => paginate(num)}>{num}</button></li>
									))
								}
								<li className={"page-item " + ((active === dati.pagina) ? 'active' : null)}><button className="page-link">{dati.pagina}</button></li>
								{
									pagine.after.map((num) => (
										<li key={num} className={"page-item " + ((active === num) ? 'active' : null)}><button className="page-link" onClick={() => paginate(num)}>{num}</button></li>
									))
								}

								<li className="page-item">
									<button className="page-link" onClick={pagine.last ? () => paginate(pagine.last) : null} aria-label="Next">
										<span aria-hidden="true">&raquo;</span>
									</button>
								</li>
							</ul>
						</nav>
					</div>
					<div className="col-md-4"></div>
				</div>
				<br />
			</div>

		) : null
	);
};

export default Consuntivo;